import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Idea() {
  return (
    <section className="nurs_idea p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={5}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center my-auto order-md-1 order-2"
          >
            <div className="solution_img">
              <StaticImage
                src="../../../images/case-studies/selah/tek_img_01.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={608}
                height={650}
              />
            </div>
          </Col>
          <Col
            xs={12}
            md={7}
            lg={7}
            xl={6}
            xxl={6}
            className="offset-xl-1 my-auto order-md-2 order-1"
          >
            <h2>
              The Concept Behind 
              <span style={{ color: "#00ADEF" }}>Selah</span>
            </h2>
            <p>
              The client wanted to create a dedicated social platform where
              people could create groups with friends and family, socialize with
              people from their social circle, and share pictures, videos,
              events, and other stuff to keep in touch with others.
            </p>
            <p>
              The idea was to build a separate networking platform for family
              and friends where there would be no distractions and people that
              use social platforms to stay connected to their family and friends
              would not end up wasting hours scrolling the feed.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Idea;
